import { GeneratedSummaryProps, SummaryTextArea } from './CustomTextEditor';

export default function StandupSummary({
  isLoading,
  generatedSummary,
}: {
  isLoading: boolean;
  generatedSummary: GeneratedSummaryProps;
}): JSX.Element {
  return (
    <div className="flex flex-col gap-4">
      <SummaryTextArea
        generatedSummary={generatedSummary}
        isLoading={isLoading}
      />
    </div>
  );
}
